export const outlookConfig = {
  clientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID,
  authority: 'https://login.microsoftonline.com/common',
  redirectUri: process.env.REACT_APP_OUTLOOK_REDIRECT_URI || window.location.origin,
  scopes: [
    'User.Read',
    'Calendars.ReadWrite',
    'offline_access'
  ]
}; 